import { Link } from 'react-router';
import { formatDate, formatCurrencyNoDecimals } from '@/utils/formatters';
import type { PrepaymentSource } from '../services/drawdowns-service';

interface PrepaymentSourcesProps {
  sources: PrepaymentSource[];
  unattributed: number;
}

export function PrepaymentSources({
  sources,
  unattributed,
}: PrepaymentSourcesProps) {
  return (
    <div className="space-y-1 pl-3 text-xs text-muted-foreground">
      {sources.map((source) => {
        const drawdownLabel = `Drawdown #${source.drawdown_number}`;
        return (
          <div key={source.drawdown_id}>
            <div className="flex justify-between">
              <span>
                From{' '}
                {source.is_viewable ? (
                  <Link
                    to={`/portal/transactions/drawdowns/${source.drawdown_id}`}
                    className="underline hover:text-foreground"
                  >
                    {drawdownLabel}
                  </Link>
                ) : (
                  drawdownLabel
                )}{' '}
                ({formatDate(source.issue_date)})
              </span>
              <span>{formatCurrencyNoDecimals(source.amount)}</span>
            </div>
            {source.bank_transfers.map((transfer) => (
              <div key={transfer.id} className="pl-3">
                {formatCurrencyNoDecimals(transfer.amount, transfer.currency)}{' '}
                of a bank transfer
                {transfer.counterparty_name && (
                  <> from {transfer.counterparty_name}</>
                )}{' '}
                on {formatDate(transfer.transfer_date)}
              </div>
            ))}
            {!source.is_settled && (
              <div className="pl-3">Not fully paid yet</div>
            )}
          </div>
        );
      })}
      {unattributed > 0 && (
        <div className="flex justify-between">
          <span>Funding drawdown not on record</span>
          <span>{formatCurrencyNoDecimals(unattributed)}</span>
        </div>
      )}
    </div>
  );
}
